export const deg2rad = (degrees: number) => degrees / 180 * Math.PI;
